export const ui = {
  redirectToLoginPage: false
};